<template>
  <div class="footer">
    <div class="main">
      <!-- logo -->
      <div class="slogan">
        <div class="logo">
          <img src="@/assets/images/white-logo.png" alt="兮易强企" />
        </div>
        <div class="text">
          以非凡的能力体系，专注企业服务，为客户和社会持续创造最大价值
        </div>
      </div>
      <!-- 菜单 -->
      <div class="layout">
        <div class="menu">
          <ul>
            <li class="sum">产品</li>
            <li v-for="item in menu[0]" :key="item.path" @click="toMenu(item.path)">{{ item.name }}</li>
          </ul>
          <ul>
            <li class="sum">解决方案</li>
            <li v-for="item in menu[1]" :key="item.path" @click="toMenu(item.path)">{{ item.name }}</li>
          </ul>
          <ul>
            <li class="sum">智能制造</li>
            <li v-for="item in menu[2]" :key="item.path" @click="toIntelligent(item.path)">{{ item.name }}</li>
          </ul>
          <!-- <ul>
            <li class="sum">平台服务</li>
            <li v-for="item in menu[3]" :key="item.path" @click="toMenu(item.path)">{{ item.name }}</li>
          </ul> -->
          <ul>
            <li class="sum">客户案例</li>
            <li v-for="item in menu[4]" :key="item.path" @click="toMenu(item.path, item.value)">{{ item.name }}</li>
          </ul>
          <ul>
            <li class="sum">新闻动态</li>
            <li v-for="item in menu[5]" :key="item.path" @click="toMenu(item.path)">{{ item.name }}</li>
          </ul>
          <ul>
            <li class="sum">关于我们</li>
            <li v-for="item in menu[6]" :key="item.name" @click="toAbout()">{{ item.name }}</li>
          </ul>
        </div>
        <div class="QR">
          <div class="item">
            <div class="name">微信公众号</div>
            <div class="code">
              <img src="@/assets/images/wx1.jpg" alt="" />
            </div>
          </div>
          <div class="item">
            <div class="name">广乾草记</div>
            <div class="code">
              <img src="@/assets/images/wx3.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bootom">
      Copyright 2016 北京兮易信息科技有限公司
      <a class="contact_beian" target="_blank" href="https://beian.miit.gov.cn">京ICP备15047697号-1</a>
    </div>
  </div>
</template>

<script>
import { getDictData } from "@/request/api.js";
export default {
  data() {
    return {
      menu: [
        [
          {
            path: '/product/consultation',
            name: '企业核心能力评估诊断'
          },
          {
            path: '/product/talents',
            name: '组织与人才发展'
          },
          // {
          //   path: '2-3',
          //   name: 'MES'
          // },
          {
            path: '/product/cloud',
            name: '产业云图'
          },
          {
            path: '/product/digitalHuman',
            name: '岗位数字人'
          },
          // {
          //   path: '/product/intelligent',
          //   name: '智能制造'
          // },
        ],
        [
          {
            path: '/solution/planning',
            name: '企业核心能力咨询规划'
          },
          {
            path: '/solution/talentDevelopment',
            name: '组织与人才发展'
          },
          // {
          //   path: '/solution/intelligentManufacturing',
          //   name: '智能制造'
          // },
          // {
          //   path: '/solution/consultation',
          //   name: '诊断咨询'
          // },
        ],
        [
          {
            path: '/intelligent/index',
            name: '行业解决方案'
          },
          {
            path: '/intelligent/index',
            name: '精选解决方案'
          },
          {
            path: '/intelligent/index',
            name: '供应链一体化平台'
          },
          {
            path: '/intelligent/index',
            name: '我们的方案优势'
          },
        ],
        [],
        [],
        [],
        [
          {
            path: 'briefIntroduction',
            name: '公司简介'
          },
          {
            path: 'value',
            name: '核心价值观'
          },
          {
            path: 'course',
            name: '发展历程'
          },
          {
            path: 'team',
            name: '关于团队'
          },
          {
            path: 'contact',
            name: '联系我们'
          }
        ]
      ],
      typeList: []
    }
  },
  methods: {
    toMenu (path, dictValue) {
      if (dictValue) {
        path = path + '?type=' + dictValue;
      }
      this.$router.push(path)
    },
    toAbout() {
      this.$router.push('/about/index')
    },
    toIntelligent() {
      this.$router.push('/intelligent/index')
    },
    getDict() {
      getDictData("case_type").then((res) => {
        this.typeList = res.data;
        const head = res.data.map(item => ({ path: '/case/list', name: item.dictLabel, value: item.dictValue }))
        this.$set(this.menu, 4, head) // 替换数组的第一个元素为新的数组，保留其他元素不变
      });
    },
  },
  mounted() {
    this.getDict();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background: #0a2947;

  .main {
    width: 1400px;
    margin: 0 auto;
    padding: 50px 0 68px 0;

    .slogan {
      display: flex;

      // align-items: flex-end;
      .logo {
        height: 50px;
        width: auto;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        font-size: 20px;
        line-height: 20px;
        color: #ffffff;
        margin-left: 20px;
        padding-top: 20px;
      }
    }

    .layout {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 62px;

      .menu {
        display: flex;

        ul {
          margin-right: 55px;

          li {
            color: #91a3b6;
            font-size: 14px;
            line-height: 14px;
            margin: 15px 0;
            cursor: pointer;
          }

          .sum {
            font-size: 18px;
            color: #ffffff;
            line-height: 32px;
            margin-top: 0;
            margin-bottom: 24px;
            cursor: default;
          }
        }
      }

      .QR {
        display: flex;

        .item {
          margin-right: 45px;
          &:last-child {
            margin-right: 0;
          }

          .name {
            font-size: 18px;
            color: #ffffff;
            line-height: 32px;
            text-align: center;
            margin-bottom: 12px;
          }

          .code {
            width: 137px;
            height: 137px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .bootom {
    text-align: center;
    padding: 10px 0;
    color: #fff;

    .contact_beian {
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue